










import Vue from "vue";
export default Vue.extend<{}, {}, {}, Props>({
  props: {
    isUnread: {
      type: Boolean,
      default: false,
    },
  },
});

interface Props {
  isUnread: boolean;
}
